import { Fragment } from 'react';
import { Button, Kbd } from '../components';
import { Dialog } from './Dialog';

export interface Shortcut {
  /** The keys, in order: "then" presses them one after the other, otherwise they're alternatives. */
  keys: string[];
  then?: boolean;
  does: string;
}

export interface ShortcutGroup {
  label: string;
  shortcuts: Shortcut[];
}

/** The full list of keyboard shortcuts, opened with `?`. */
export function ShortcutSheet({
  open,
  onOpenChange,
  groups,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groups: ShortcutGroup[];
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Keyboard shortcuts"
      description="Letter keys don't act while you're typing in a field."
      footer={<Button onClick={() => onOpenChange(false)}>Close</Button>}
    >
      <div className="rq-keys">
        {groups.map((group) => (
          <section key={group.label} className="rq-keys-group">
            <h3 className="text-subheading rq-keys-label">{group.label}</h3>
            <dl className="rq-keys-list">
              {group.shortcuts.map((shortcut) => (
                <div key={shortcut.keys.join() + shortcut.does} className="rq-keys-row">
                  <dt className="rq-keys-keys">
                    {shortcut.keys.map((key, i) => (
                      <Fragment key={key}>
                        {i > 0 ? (
                          <span className="rq-keys-join">{shortcut.then ? 'then' : '/'}</span>
                        ) : null}
                        <Kbd>{key}</Kbd>
                      </Fragment>
                    ))}
                  </dt>
                  <dd className="rq-keys-does">{shortcut.does}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
